export default __webpack_public_path__ + "images/b6883a580bf5217ab28afefa661ad897-disaster_relief.webp";